import type { Component, Entity2D } from '../../odie';
import type { GameScene } from '../GameScene';

import { ThrowerBlockProps } from '../defs/block';
import { ThrowerBlockView } from '../views/blocks/ThrowerBlockView';

// types
//-----------------------------------------------------------------------------
export type ThrowerBlockComponentOptions = {
  props: ThrowerBlockProps;
  option?: number;
};

/*
    thrower block component
*/
export class ThrowerBlockComponent implements Component {
  // constants
  //-------------------------------------------------------------------------
  public static readonly NAME = 'blockThrower';

  // fields
  //-------------------------------------------------------------------------
  // injected
  public entity!: Entity2D;
  // scene
  public view!: ThrowerBlockView;

  // impl
  //-------------------------------------------------------------------------
  public init(options: ThrowerBlockComponentOptions): void {
    // create view
    this.view = new ThrowerBlockView(options.props);
    this.entity.c.block.signals.onGameStart.connect(() =>
      this.updateEnabledState(),
    );
  }

  public updateEnabledState() {
    const scene = this.entity.scene as GameScene;
    if (!scene) return;
    const remaining = scene.sessionEntity.c.state.cageThrowsRemaining;
    this.view.enabled = remaining > 0;
  }
}
